export default __webpack_public_path__ + "static/media/refresh.57db1f25.svg";